import { ICategory } from 'app/main/shared/shared/table/components/category-name/category-name.component';
import { FieldData, ILayoutSettings, RecipientRole } from '../../edit-template/edit-template.dto';
import { IMetadataItemDto, ValidationTypeEnum } from '../../settings/documentfields/metadata-item.dto';
import { TemplateType } from '../../templates/template.dto';
import { IDocumentFieldsDataItemCommon } from './document-listing.dto';
import { ISection } from '../../settings/documenttype/document-type-settings-modal/document-type-settings.dto';

export interface IDocumentDetailRootDTO {
  template?:  Template
  template_details?: TemplateDetails
  template_roles: TemplateRole[]
  detailFieldValues: IDetailFieldValuesDTO[]
  template_fields_datas?: TemplateFieldsDatas
  contract_control_multi_sections?: ContractControlMultiSection[]
  document_internal_reminder?: DocumentInternalReminder[]
  is_reminders_expire?: boolean
  tags?: Tag[],
  layout_settings: ISection,
  document_special_action?: string | null
}

export interface IDetailFieldValuesDTO {
  id: number
  document_id: number
  metadata_id: number
  metadata: IMetadataItemDto
  value: string | number
  old_value: string | number
  created_at: string
  updated_at: string
}


export interface Template {
    content: string;
    created_at: string;
    file?: string;
    id: number;
    name: string;
    status: string|number;
    template_id: number;
    thumbnail: string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
    can_edit?: boolean;
    category?: ICategory;
    categories?: ICategory[];
}

export enum DocumentDetailsStatus {
    Approved = "approved",
    Delivered = "delivered",
    Draft = "draft",
    Expired = "expired",
    Failed = "failed",
    Revoked = "revoked",
    Sent = "sent",
    Signed = "signed",
    Uploaded = "uploaded",
    Viewed = "viewed",
}

export enum DocumentVideoType {
    Library = "library",
    Vimeo = "vimeo",
    Youtube = "youtube",
}

export enum VisibilityEnum {
    Private = "private",
    Public = "public",
}

export interface TemplateDetails {
    attach_video?: number;
    allow_chat?: number;
    confirmation_message: string;
    dk_password: string;
    dk_password_hint: string;
    dk_send_via_sms: number;
    dk_type: string;
    document_key: number;
    document_number: string;
    document_type_id: number;
    document_type_name: string;
    due_date: string;
    folder_name: string;
    folders: {id:number, name:string}[];
    folders_id: number;
    invitation_message: string;
    language: string;
    recurring: number;
    save_to_folder: number;
    signing_deadline: string;
    signing_reminder: string;
    external_chat: boolean;
    status: DocumentDetailsStatus;
    video_title: string;
    video_type: DocumentVideoType;
    video_url: string;
    visibility: VisibilityEnum;
    visible_name: string;
    category_id?: number;
    category?: ICategory;
    type: TemplateType;
    is_uploaded?: number | boolean;
    category_ids: number[];
    categories?: ICategory[];
}

export interface TemplateRole extends RecipientRole{
  recipient_role_detail:RecipientRoleDetail
}


export interface Validations {
  id: number
  user_id: number
  workspace_id: number
  recipient_role_extrafield_id: number
  fieldable_id: number
  fieldable_type: string
  min: number
  max: number
  decimals: number
  regular_expression: string
  validation_help_text: string
  validation_type: ValidationTypeEnum
  number_validation_type: string
  created_at: string
  updated_at: string
}

export interface Recipient {
    address: string;
    city: string;
    created_at: string;
    email: string;
    firstname: string;
    id: number;
    lastname: string;
    organization_id: number;
    persnol_no: string;
    phone_no: string;
    profile_image?: string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
    zipcode: string;
}

export interface RecipientRoleDetail {
    allow_to_forward: number;
    allow_to_read: number;
    created_at: string;
    dk_pin_code: string;
    email_failed_reason: string;
    id: number;
    ip_address: string;
    is_sender: number;
    part_by: string;
    recipient_role_id: number;
    reject_comment: string;
    signature_image: string;
    signature_type: string;
    status: string;
    status_updated_at: string;
    third_party_auth_response: string;
    unique_id: string;
    updated_at: string;
    user_id: number;
    workspace_id: number;
}

export interface User {
  id: number
  tenant_owner: boolean
  name: string
  email: string
  status: string
  phone: string
  profile_image: string
  signature: string
  login_via: string
}

export interface TemplateFieldsDatas {
  id: number
  user_id: number
  workspace_id: number
  dataable_id: number
  dataable_type: string
  data: FieldData[]
  created_at?: string
  updated_at?: string
}

export interface Data {
  "290061": N290061
  blocks: Blocks
}

export interface N290061 extends IDocumentFieldsDataItemCommon{
    
}

export interface Blocks {
  "459618": N459618
}

export interface N459618 {
  lock: number
  name: string
  type: string
  uuid: string
  fields: string[]
  role_id: number
  background_image: string
  connected_parent_conditional_id: number[]
}

export interface ContractControlMultiSection {
  id: number
  user_id: number
  workspace_id: number
  contract_control_id: number
  created_at: string
  updated_at: string
  sectionable_type: string
  sectionable_id: number
  contract_control: ContractControl
}

export interface ContractControl {
  id: number
  user_id: number
  workspace_id: number
  contract_control_name: string
  document_type_id: number
  category_id: number
  organization_id: number
  contract_control_image: string
  contract_no: string
  is_active: number
  contract_type: number
  parent_contract: number
  original_import_file_name: string
  created_at: string
  updated_at: string
  filter_range: string
}

export interface DocumentInternalReminder {
  id: number
  user_id: number
  document_id: number
  reminder_datetime: string
  message: string
  created_at: string
  updated_at: string
  users?: User[]
}

export interface Tag {
  value: string
}

